"use strict";

exports.__esModule = true;
exports.DateRangePicker = void 0;

var React = _interopRequireWildcard(require("react"));

var _popover = require("@manifest-ui/popover");

var _DateRangePicker = require("./DateRangePicker.styles");

var _icons = require("@manifest-ui/icons");

var _hooks = require("@manifest-ui/hooks");

var _jsxFileName = "/home/runner/work/manifest-ui/manifest-ui/packages/date-range/src/DateRangePicker.tsx";

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const DateRangePicker = React.forwardRef((props, ref) => {
  const {
    defaultValue,
    isDisabled,
    onChange,
    placeholder,
    value: valueProp,
    ...other
  } = props;
  const [value, setValue] = (0, _hooks.useControlled)({
    defaultValue: defaultValue ?? {
      endDate: undefined,
      startDate: new Date()
    },
    onChange,
    value: valueProp
  });
  const hasValues = value?.endDate && value.startDate;
  const handleChange = React.useCallback(({
    range1
  }) => {
    setValue(range1);
  }, [setValue]);
  return React.createElement(_popover.Popover, {
    align: "start",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 7
    }
  }, React.createElement(_popover.PopoverTrigger, {
    disabled: isDisabled,
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 9
    }
  }, React.createElement(_DateRangePicker.StyledInput, {
    className: "manifestui-date-range-picker__input",
    "data-disabled": isDisabled ? '' : null,
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 11
    }
  }, !hasValues && React.createElement(_DateRangePicker.StyledPlaceholder, {
    className: "manifestui-date-range-picker__placeholder",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 15
    }
  }, placeholder), hasValues && React.createElement(_DateRangePicker.StyledValue, {
    className: "manifestui-date-range-picker__value",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82,
      columnNumber: 15
    }
  }, `${value?.startDate?.toLocaleDateString()} - ${value?.endDate?.toLocaleDateString()}`), React.createElement(_DateRangePicker.StyledInputIcon, {
    className: "manifestui-date-range-picker__input-icon",
    "data-disabled": isDisabled ? '' : null,
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 86,
      columnNumber: 13
    }
  }, React.createElement(_icons.ExpandMore, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 90,
      columnNumber: 15
    }
  })))), React.createElement(_popover.PopoverContent, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 94,
      columnNumber: 9
    }
  }, React.createElement(_DateRangePicker.StyledDateRange, _extends({
    className: "manifestui-date-range",
    onChange: handleChange,
    ranges: [value],
    ref: ref
  }, other, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 95,
      columnNumber: 11
    }
  }))));
});
exports.DateRangePicker = DateRangePicker;
DateRangePicker.displayName = 'DateRangePicker';